import { API_JWT_TOKEN_NAME, CALL_API } from '../middleware/api'

export const PHONE_NUMBER_SEARCH_REQUEST = 'PHONE_NUMBER_SEARCH_REQUEST'
export const PHONE_NUMBER_SEARCH_SUCCESS = 'PHONE_NUMBER_SEARCH_SUCCESS'
export const PHONE_NUMBER_SEARCH_FAILURE = 'PHONE_NUMBER_SEARCH_FAILURE'
export const PHONE_NUMBER_SEARCH_RESET = 'PHONE_NUMBER_SEARCH_RESET'

export const searchPhoneNumberTransactions = (phone) => ({
  [CALL_API]: {
    endpoint: `/api/phone-search/?phone_number=${encodeURIComponent(phone)}`,
    types: [PHONE_NUMBER_SEARCH_REQUEST, PHONE_NUMBER_SEARCH_SUCCESS, PHONE_NUMBER_SEARCH_FAILURE],
    method: 'GET',
    tokenType: API_JWT_TOKEN_NAME,
  },
})

const reset = () => ({
  type: PHONE_NUMBER_SEARCH_RESET,
})
export const resetSearchPhoneNumberTransactions = () => (dispatch) => dispatch(reset())
